import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import PowerCalendar from 'ember-power-calendar/components/power-calendar';
// eslint-disable-next-line import-x/no-named-as-default
import powerCalendarFormatDate from 'ember-power-calendar/helpers/power-calendar-format-date';
import { eq } from 'ember-truth-helpers';
import dayjsFormat from 'lumen/helpers/dayjs-format';
import dayjsToDate from 'lumen/helpers/dayjs-to-date';

interface GeneralCalendarsMonthsCalendarMonthSignature {
  Args: {
    maxDate: unknown;
    minDate: unknown;
    month: unknown;
    selectDay: unknown;
    selected: unknown;
  };
}

export default class GeneralCalendarsMonthsCalendarMonth extends Component<GeneralCalendarsMonthsCalendarMonthSignature> {
  @service declare dates: Services['dates'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get monthFormat() {
    return this.dates.partialDateFormat?.YEAR_AND_MONTH_LONG;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get todayFormatted() {
    return this.hotelAndMarketService.getLocalTime().format('YYYY-MM-DD');
  }

  <template>
    {{! @glint-nocheck }}
    <div class="month-container">
      <div class="month-date-picker">
        <PowerCalendar
          @center={{@month}}
          @onSelect={{@selectDay}}
          @selected={{@selected}}
          class="demo-calendar-small"
          as |calendar|
        >
          <calendar.Nav>
            {{powerCalendarFormatDate
              calendar.center
              this.monthFormat
              locale=calendar.locale
            }}
          </calendar.Nav>
          <calendar.Days
            @maxDate={{dayjsToDate @maxDate}}
            @minDate={{dayjsToDate @minDate}}
            @showDaysAround={{false}}
            @startOfWeek={{this.dates.startOfWeek}}
            @weekdayFormat="min"
            as |day|
          >
            <div
              class="day-cell
                {{if
                  (eq
                    (dayjsFormat day.date format="YYYY-MM-DD")
                    this.todayFormatted
                  )
                  'today'
                }}"
            >
              {{day.number}}
            </div>
          </calendar.Days>
        </PowerCalendar>
      </div>
    </div>
  </template>
}
